module.exports = __webpack_public_path__ + "img/26.4ec65ca0.svg";